"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTitle = getTitle;
exports.getUrl = getUrl;
exports.getUrlPathName = getUrlPathName;
exports.isAndroidOrIos = isAndroidOrIos;
exports.isMobile = isMobile;

function getUrlPathName(url) {
  var _url$split, _url$split$call, _fin, _fin$split, _fin$split$call;

  if (!url) return '';
  let fin = '';
  fin = url === null || url === void 0 ? void 0 : (_url$split = url.split) === null || _url$split === void 0 ? void 0 : (_url$split$call = _url$split.call(url, '#')) === null || _url$split$call === void 0 ? void 0 : _url$split$call[1];
  fin = (_fin = fin) === null || _fin === void 0 ? void 0 : (_fin$split = _fin.split) === null || _fin$split === void 0 ? void 0 : (_fin$split$call = _fin$split.call(_fin, '?')) === null || _fin$split$call === void 0 ? void 0 : _fin$split$call[0];
  return fin;
}

function getUrl() {
  var _window, _window$location;

  return getUrlPathName((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.href);
}

function isMobile() {
  var _agents$filter, _window2, _window2$location, _window2$location$hos, _window2$location$hos2;

  const userAgent = navigator.userAgent;
  const agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
  return ((_agents$filter = agents.filter(item => userAgent.includes(item))) === null || _agents$filter === void 0 ? void 0 : _agents$filter.length) > 0 || ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : (_window2$location$hos = _window2$location.hostname) === null || _window2$location$hos === void 0 ? void 0 : (_window2$location$hos2 = _window2$location$hos.includes) === null || _window2$location$hos2 === void 0 ? void 0 : _window2$location$hos2.call(_window2$location$hos, 'fleetmobile'));
}

function isAndroidOrIos() {
  const u = navigator.userAgent;
  const isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
  if (isIos) return 'IOS';
  if (isAndroid) return 'Android';
  return '';
}

function getTitle() {
  var _document, _window3;

  return ((_document = document) === null || _document === void 0 ? void 0 : _document.title) || ((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.title) || '';
}